












































import { storePasien } from "@/store/modules/pasien";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component({})
export default class CardModalAlergi extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() alergi!: string;

  saveAlergi() {
    this.$emit("addAlergi", this.alergi);
    this.show = false;
    this.alergi = "";
  }

  close() {
    this.show = false;
  }

  @Watch("value")
  changeValue(val) {
    if (val) {
      this.alergi = storePasien.identitasPasien?.alergi;
    } else {
      this.alergi = "";
    }
  }

  get show() {
    return this.value;
  }

  set show(value) {
    this.$emit("input", value);
  }
}
